<div class="chat-page-container">
  <div class="chat-page-container-header">
    <div class="chat-page-container-header-live">
      {{ languageService.translate(['LIVE CHAT', 'ОНЛАЙН-ЧАТ']) }}
    </div>
    <div class="chat-page-container-header-status">
      <div class="chat-page-container-header-status-ball"
           [class.animate-pulse]="chatOnlineStatus === 'Online'"
           [class.ball-grey]="chatOnlineStatus === 'Offline'"
      ></div>
      <div class="chat-page-container-header-status-text"
           [style.text-decoration]="chatOnlineStatus === 'Offline' ? 'line-through' : ''">

        {{ languageService.translate(['Meet+Greet is', 'Meet+Greet']) }}

        <span *ngIf="chatOnlineStatus === 'Online'">{{ languageService.translate(['online', 'онлайн']) }}</span>

        <span *ngIf="chatOnlineStatus === 'Offline'">{{ languageService.translate(['offline', 'офлайн']) }}</span>
      </div>
    </div>
  </div>

  <div class="chat-page-container-workspace">
    <div class="chat-page-container-workspace-chat">
      <div class="chat-page-container-workspace-chat-section" *ngFor="let section of chatSections">
        <div class="chat-page-container-workspace-chat-section-message-bloc"
             *ngFor="let block of section.messages">
          <div
            class="chat-page-container-workspace-chat-section-message-bloc-user"
            [class.you]="block.user === 'You'"
          >
            {{ block.user === 'You'
            ? languageService.translate(['You', 'Вы'])
            : block.user }}
          </div>
          <div class="chat-page-container-workspace-chat-section-message-bloc-message">
            <div class="chat-page-container-workspace-chat-section-message-bloc-message-text">
              <div *ngIf="!block.isImage" class="message-text-content">
                {{block.message}}
              </div>
              <div *ngIf="block.isImage" class="message-image-container">
                <img [src]="block.message"
                     alt="Sent image"
                     class="sent-image"
                     (click)="openModal(block.message)">
              </div>
            </div>
            <div class="chat-page-container-workspace-chat-section-message-bloc-message-date">
              {{block.time}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="chat-page-container-workspace-tapping" *ngIf="tapping">
      {{ languageService.translate([
      'Meet+Greet Assist is typing...',
      'Meet+Greet Assist печатает...'
    ]) }}
    </div>
  </div>
  <div class="chat-page-container-input">
    <div class="chat-page-container-input-plus" (click)="triggerImageUpload()">+</div>
    <input type="file" id="imageUpload" style="display: none;" (change)="onImageSelected($event)" accept="image/*">
    <input type="text"
           [placeholder]="languageService.translate(['Write a message...','Напишите сообщение...'])"
           [(ngModel)]="newMessageText"
           (keyup.enter)="onSendMessage()"
           (input)="onInputChange()">
    <div class="chat-page-container-input-button" (click)="onSendMessage()">{{ languageService.translate(['Send', 'Отправить']) }}</div>
  </div>

  <div class="modal-overlay" *ngIf="showModal" (click)="closeModal()">
    <div class="modal-overlay-content" (click)="$event.stopPropagation()">
      <img [src]="modalImageUrl" alt="Full size image" class="modal-overlay-content-image">
      <div class="modal-overlay-content-close" (click)="closeModal()">×</div>
    </div>
  </div>
</div>
